<template>
  <div class="modal-overlay" id="modal-troubleshooting-history">
    <div class="modal modal-container">
      <div class="modal-top">
        <h3 class="modal-caption">トラブル内容</h3>
      </div>
      <div class="modal-content">
        <div class="model-field">
          <label class="label-dg" for="trouble-content">トラブル内容</label>
          <textarea
            id="trouble-content"
            name="trouble-content"
            class="text-line"
            data-vv-as="トラブル内容"
            v-validate="'required'"
            v-model="dataTroubleInfo.trouble_content">
          </textarea>
          <div class="err_message">
            {{ errors.first("trouble-content") }}
          </div>
          <label class="label-dg" for="trouble-cause">原因</label>
          <textarea
            id="trouble-cause"
            name="trouble-cause"
            class="text-line"
            data-vv-as="原因"
            v-validate="'required'"
            v-model="dataTroubleInfo.trouble_cause">
          </textarea>
          <div class="err_message">
            {{ errors.first("trouble-cause") }}
          </div>
          <label class="label-dg" for="process-content">対応内容</label>
          <textarea
            id="process-content"
            name="process-content"
            class="text-line"
            data-vv-as="対応内容"
            v-model="dataTroubleInfo.process_content">
          </textarea>
          <div class="err_message">
            {{ errors.first("process-content") }}
          </div>
          <label class="label-dg" for="name">対応者</label>
          <input
            id="name"
            name="name"
            type="text"
            class="input-field"
            data-vv-as="対応者"
            maxlength="64"
            v-validate="'required'"
            v-model="dataTroubleInfo.name"
          >
          <div class="err_message">
            {{ errors.first("name") }}
          </div>
          <div class="corresponding-period">
            <label class="label-dg" for="corresponding-period">
              対応期間
            </label>
            <div class="corresponding-period-content">
              <datepicker
                :minimum-view="'day'"
                format="yyyy/MM/dd"
                :language="ja"
                input-class="input-date"
                class="input-time-left"
                :disabled-dates="dayInfo.disabled.start"
                v-model="getStartDay"
              ></datepicker>
              <span class="span-time-center">~</span>
              <datepicker
                :minimum-view="'day'"
                format="yyyy/MM/dd"
                :language="ja"
                input-class="input-date"
                class="input-time-right"
                :disabled-dates="dayInfo.disabled.end"
                v-model="getEndDay"
              ></datepicker>
            </div>
          </div>
        </div>
        <div class="modal-bottom">
          <ul class="modal-bottom-button">
            <button class="modal-bottom-button-item bt-cyan"
              @click="onCreate" v-if="actionDialog === actionCompare[0]">
              登録
            </button>
            <button class="modal-bottom-button-item bt-cyan"
              @click="onUpdate" v-if="actionDialog === actionCompare[1]">
              更新
            </button>
            <button class="modal-bottom-button-item bt-gray"
              @click="onCancel">
              キャンセル
            </button>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
import Datepicker from "vuejs-datepicker";
import { ja } from "vuejs-datepicker/dist/locale";

export default {
  name: "troubleshooting-history-dialog",
  components: {
    Datepicker,
  },
  props: ["troubleId", "action"],
  data: function() {
    return {
      moment: moment,
      ja: ja,
      actionCompare: ['create', 'update'],
      actionDialog: this.action,
      formatDate: "YYYY/MM/DD",
      formatDateUTC: "YYYY-MM-DD",
      timeDefaultUTC: "T11:00:01Z",
      dataTroubleInfo: {
        trouble_content: '',
        trouble_cause: '',
        process_content: '',
        name: '',
        start_date: '',
        end_date: ''
      },
      dayInfo: {
        disabled: {
          start: { from: null, to: null },
          end: { from: null, to: null },
        },
        param: {
          start: null,
          end: null,
        },
      },
    };
  },
  computed: {
    getStartDay: {
      get: function() {
        return this.getDateWithFormat(this.dayInfo.param.start);
      },
      set: function(newValue) {
        this.dayInfo.param.start = this.setDateWithFormat(newValue);
        this.setDisabledDate();
      },
    },
    getEndDay: {
      get: function() {
        return this.getDateWithFormat(this.dayInfo.param.end);
      },
      set: function(newValue) {
        this.dayInfo.param.end = this.setDateWithFormat(newValue);
        this.setDisabledDate();
      },
    },
  },
  methods: {
    getTroubleInfo: function (troubleId) {
      this.$axios.get(`/srv/api/trouble_info/${troubleId}`, {
        withCredentials: true
      }).then(response => {
        if (typeof response.data == "object") {
          this.dataTroubleInfo = response.data;
          this.dayInfo.param.start =  moment(new Date(this.dataTroubleInfo.start_date).toISOString()).format('YYYY-MM-DD');
          this.dayInfo.param.end = moment(new Date(this.dataTroubleInfo.end_date).toISOString()).format('YYYY-MM-DD');
          this.setDisabledDate();
        } else {
          alert("session time out");
          this.$store.dispatch("logout");
          this.$router.push("/login");
        }
      }).catch();
    },
    onCreate: function() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.dataTroubleInfo.start_date = this.dayInfo.param.start;
          this.dataTroubleInfo.end_date = this.dayInfo.param.end;
          this.$emit('onCreate', this.dataTroubleInfo);
        }
      });
    },
    onUpdate: function() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.dataTroubleInfo.start_date = this.dayInfo.param.start;
          this.dataTroubleInfo.end_date = this.dayInfo.param.end;
          this.$emit('onUpdate', this.dataTroubleInfo);
        }
      });
    },
    onCancel: function() {
      this.$emit("close");
    },
    getDateWithFormat(value) {
      return moment(value).format('YYYY-MM-DD');
    },
    setDateWithFormat(value) {
      if (value) {
        return moment(new Date(value).toISOString().split('T')[0]).format('YYYY-MM-DD');
      } else {
        return moment(new Date().toISOString().split('T')[0]).format('YYYY-MM-DD');
      }
    },
    setDisabledDate: function() {
      const endDateFormat = moment(
        new Date(this.dayInfo.param.end).toISOString().split('T')[0]
      ).format(this.formatDateUTC);
      this.dayInfo.disabled.start.from = new Date(
        new Date(endDateFormat + this.timeDefaultUTC)
      );
      const startDateFormat = moment(
        new Date(this.dayInfo.param.start).toISOString().split('T')[0]
      ).format(this.formatDateUTC);
      this.dayInfo.disabled.end.to = new Date(
        this.subtractionOneDay(new Date(startDateFormat + this.timeDefaultUTC))
      );
    },
    subtractionOneDay: function(date = new Date()) {
      date.setDate(date.getDate() - 1);
      return date;
    }
  },
  mounted: function() {
    if (this.actionDialog === this.actionCompare[0]) {
      this.dayInfo.param.start = this.setDateWithFormat();
      this.dayInfo.param.end = this.setDateWithFormat();
      this.setDisabledDate();
    } else {
      this.getTroubleInfo(this.troubleId);
    }
  }
};
</script>